module.exports = __webpack_public_path__ + "assets/img/btn-detail-c20136f2.png";